/// <reference path="./dto/com.rico.sb2.service.system.ts" />

import {WebSocketClient} from "./WebSocketClient";
import {createHtmlElement} from "./lib/domFunctions";
import {escapeHTML} from "./lib/escapeHTML";
import JournalListItem = com.rico.sb2.service.system.JournalListItem;
import {moment} from "./boot";

const EVENTS_LIMIT = 100;

function maxLevelOfEvents(a: string, b: string) {
	console.info([a, b]);
	if (a === '') return b;
	if (b === '') return a;

	const weights: { [key: string]: number } = {
		'TRACE': -1,
		'WARNING': 1,
		'ERROR': 2,
	};

	const aWeight = a in weights ? weights[a] : 0;
	const bWeight = b in weights ? weights[b] : 0;
	return (bWeight > aWeight) ? b : a;
}

export class JournalOffscreen {
	private readonly list: HTMLElement;
	private unread = 0
	private unreadMaxLevel = ''

	constructor(list: HTMLElement) {
		this.list = list;

		WebSocketClient
			.instance()
			.subscribe('/topic/journal', m => this.onEvent(m))

		setInterval(this.updateAgo.bind(this), 30000);


		this.offcanvas?.addEventListener('hide.bs.offcanvas', () => {
			this.unread = 0;
			this.unreadMaxLevel = '';
			this.unreadUpdate();
			this.list.querySelectorAll<HTMLElement>('.event-unread').forEach(element => element.classList.remove('event-unread'));
		})
		this.offcanvas?.addEventListener('show.bs.offcanvas', () => {
			this.updateAgo();
		})
	}

	get offcanvas() {
		return this.list.closest('.offcanvas');
	}

	get shown() {
		return this.offcanvas?.classList.contains('show') || false;
	}

	private updateAgo() {
		this.list.querySelectorAll<HTMLElement>('[data-ago-from]').forEach(element => {
			this.updateAgoOnElement(element);
		})
	}

	private onEvent(m: JournalListItem) {
		const eventLiClass = {
			'ERROR': 'alert alert-danger',
			'WARNING': 'alert alert-warning',
			'TRACE': 'alert alert-info'
		}[m.level] || 'alert alert-default';

		const eventLiIcon = {
			'ERROR': 'fa-exclamation-triangle',
			'WARNING': 'fa-exclamation-circle',
			'TRACE': 'fa-bug',
		}[m.level] || 'fa-sensor text-white';

		const userNameText = typeof m.userName === "string" && m.userName.length > 0
			? `<span class="fw-bolder fs125 me-3 text-success">${escapeHTML(m.userName)}</span>`
			: ``;
		this.list.prepend(createHtmlElement('li', {'class': `${eventLiClass} event-unread rounded-0 m-0`}, `
<div class="d-flex text-muted fs80 justify-content-between">
	<span>
		${userNameText}
		<span data-ago-from="${m.time}">${moment.utc(m.time).fromNow()}</span>
	</span>
	<span>${escapeHTML(moment(m.time).format('DD.MM.YYYY HH:mm:ss'))}</span>
</div>
<i class="fal ${eventLiIcon} me-2" title="${m.level}"></i>
<span class="text-break d-inline">${escapeHTML(m.message)}</span>
		`));

		while (this.list.childElementCount > EVENTS_LIMIT) {
			this.list.children.item(this.list.children.length - 1)?.remove();
		}

		if (this.shown) {
			return;
		}

		this.unread += 1;
		this.unreadMaxLevel = maxLevelOfEvents(this.unreadMaxLevel, m.level);
		this.unreadUpdate();
	}

	private unreadUpdate() {
		document.querySelectorAll<HTMLElement>('[data-bind="unreadEventsCount"]').forEach(element => {
			element.innerText = this.unread.toString();
		});
		document.querySelectorAll<HTMLElement>('[data-bind="unreadEventsAvailable"]').forEach(element => {
			if (this.unread > 0) {
				element.removeAttribute('hidden');
			} else {
				element.setAttribute('hidden', 'hidden');
			}
			element.classList.remove('max-', 'max-TRACE', 'max-INFO', 'max-ERROR', 'max-WARNING');
			element.classList.add(`max-${this.unreadMaxLevel}`)
		});
	}

	static setUp() {
		const list = document.getElementById('offcanvasEvents');
		if (list == null) {
			return;
		}
		new JournalOffscreen(list);
	}

	private updateAgoOnElement(element: HTMLElement) {
		const from = parseInt(element.getAttribute('data-ago-from') || '');
		if (Number.isFinite(from)) {
			const ago = moment.utc(from).fromNow();
			if (ago != element.innerText)
				element.innerText = ago;
		}
	}
}